import type { CartSuggestionCardsPreviewProduct } from './cart-suggestion-cards-block.config';
import { doodModalConfig } from './dood-modal-config';
import { propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

/** Serializable product row used in CB2 cross-selling modal preview scenarios. */
export type CrossSellingModalPreviewProduct = CartSuggestionCardsPreviewProduct;

/**
 * Serializable preview VM for `CrossSellingModalComponent`.
 * Products are runtime data (a cross-selling rule), not content-builder props.
 */
export type CrossSellingModalScenarioContent = {
  products: readonly CrossSellingModalPreviewProduct[];
};

export const CROSSSELLINGMODAL_LEGACY_FIELD_ORDER = [
  "title",
  "description",
  { type: 'groupedFields', handle: 'colors', fields: ["background_color","heading_color","description_color","productCardColors","card_color","close_icon_color","close_icon_background_color"] }
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  crossSellingModalDescriptor: _generatedCrossSellingModalDescriptor,
  crossSellingModalModalDefinition,
  crossSellingModalDashboardLayout,
  crossSellingModalConfig,
  crossSellingModalResolveConfig,
  crossSellingModalProperties,
  crossSellingModalDefinitionSetupScenarios,
} = doodModalConfig(
  {
    name: "Cross-selling modal",
    handle: "cross-selling-modal",
    internal_name: "CrossSellingModal",
    componentType: 'CrossSellingModalComponent',
    category: 'modal',
    description: "Cross-selling modal.",
    keywords: [],
    isContentModal: true,
    defaultHandle: "cross-selling-modal",
    sharedFields: {}
  },

  () => ({
    title: propertyValue({
      type: 'translation',
      value: '',
      options: {
        "label": "Title"
      }
    }),
    description: propertyValue({
      type: 'translation',
      value: '',
      options: {
        "label": "Description"
      }
    }),
    colors: {
      background_color: propertyValue({
        type: 'color',
        value: { type: 'default', value: '' },
        options: {
          "label": "Background color"
        }
      }),
      heading_color: propertyValue({
        type: 'color',
        value: { type: 'default', value: '' },
        options: {
          "label": "Heading color"
        }
      }),
      description_color: propertyValue({
        type: 'color',
        value: { type: 'default', value: '' },
        options: {
          "label": "Description color"
        }
      }),
      productCardColors: propertyValue({
        type: 'groupedFields',
        value: '',
        options: {
          "containerType": "fieldset",
          "label": "Product card colors",
          "fields": [
            {
              "handle": "textColor",
              "type": "color",
              "options": {
                "label": "Text color"
              }
            },
            {
              "handle": "cardColor",
              "type": "color",
              "options": {
                "label": "Card color"
              }
            },
            {
              "handle": "buttonBackgroundColor",
              "type": "color",
              "options": {
                "label": "Button background color"
              }
            },
            {
              "handle": "unavailableButtonBackground",
              "type": "color",
              "options": {
                "label": "Unavailable button background"
              }
            },
            {
              "handle": "unavailableButtonText",
              "type": "color",
              "options": {
                "label": "Unavailable button text"
              }
            },
            {
              "handle": "buttonTextColor",
              "type": "color",
              "options": {
                "label": "Button text color"
              }
            }
          ]
        }
      }),
      card_color: propertyValue({
        type: 'color',
        value: { type: 'default', value: '' },
        options: {
          "label": "Card color"
        }
      }),
      close_icon_color: propertyValue({
        type: 'color',
        value: { type: 'palette', value: 'primary-900' },
        options: {
          label: 'Close icon color',
        },
      }),
      close_icon_background_color: propertyValue({
        type: 'color',
        value: { type: 'palette', value: 'primary-200' },
        options: {
          label: 'Close icon background color',
        },
      }),
    }
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: ["title", "description", "colors.background_color", "colors.heading_color", "colors.description_color", "colors.productCardColors", "colors.card_color", "colors.close_icon_color", "colors.close_icon_background_color"],
          },
        ],
      },
    ],
  })
);

export function crossSellingModalDescriptor(): IBlockDescriptor;
export function crossSellingModalDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function crossSellingModalDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedCrossSellingModalDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedCrossSellingModalDescriptor, crossSellingModalProperties, fieldOrder);
}

export {
  crossSellingModalModalDefinition,
  crossSellingModalDashboardLayout,
  crossSellingModalProperties,
  crossSellingModalConfig,
  crossSellingModalResolveConfig,
  crossSellingModalDefinitionSetupScenarios,
};

export type CrossSellingModalConfig = typeof crossSellingModalConfig;
